<template>
  <v-card class="claim-card-with-details" data-testid="claim-card-with-details" elevation="0">
    <div class="header">
      <div class="header-ids">
        <Typography variant="body-2"> Submission {{ claim.formSubmissionId }} </Typography>
        <Typography variant="subtitle-1"> Claim ID: {{ claim.formSubmissionEntryId }} </Typography>
      </div>
      <Button variant="outlined" color="primary" text @click="openModal"> View Details </Button>
    </div>
    <div class="status-info">
      <ApprovedClaimDetails v-if="claim.reviewStatus === 'Approved'" :claim="claim" />
      <Typography v-if="claim.reviewStatus === 'Pending'" variant="body-2">
        Pending Audit
      </Typography>
      <Typography v-if="claim.reviewStatus === 'Denied'" variant="body-2"> Denied </Typography>
      <Typography
        variant="body-2"
        class="incentive-info"
        v-if="claim.Program && claim.Program.displayName"
      >
        Incentive: {{ claim.Program.displayName }}
      </Typography>
    </div>
    <div class="claim-info">
      <ClaimDates :claim="claim" />
      <ClaimCustomer :claim="claim" />
      <ClaimProductInfo :claim="claim" />
    </div>
    <ClaimDetailsModal :value="modalVisible" @input="modalVisible = $event" :claim="claim" />
  </v-card>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import ApprovedClaimDetails from "./claim-info/ApprovedClaimDetails.vue";
import ClaimDates from "./claim-info/ClaimDates.vue";
import ClaimCustomer from "./claim-info/ClaimCustomer.vue";
import ClaimProductInfo from "./claim-info/ClaimProductInfo.vue";
import ClaimDetailsModal from "./ClaimDetailsModal.vue";

export default {
  name: "ClaimCardWithDetails",
  components: {
    Typography,
    Button,
    ApprovedClaimDetails,
    ClaimDates,
    ClaimCustomer,
    ClaimProductInfo,
    ClaimDetailsModal,
  },
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openModal() {
      this.modalVisible = true;
    },
  },
  data() {
    return {
      modalVisible: false,
    };
  },
};
</script>

<style scoped>
.claim-card-with-details {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.header-ids {
  display: flex;
  flex-direction: column;
}
.status-info {
  padding: 0.5rem;
  padding-left: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
}

.incentive-info {
  flex-shrink: 1;
}
.claim-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 0.5rem;
  padding: 1rem;
}
</style>
